var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderHseWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.89471 4.62964L2.89471 4.52154C2.89471 3.41697 3.79014 2.52154 4.89471 2.52154L10.6603 2.52154C11.0804 2.52154 11.421 2.18093 11.421 1.76077V1.76077C11.421 1.34061 11.7616 1 12.1818 1L17 1C18.1045 1 19 1.89543 19 3L19 13C19 14.1046 18.1045 15 17 15L10.9473 15",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57941 15.0002L16.5969 15.0002C17.8469 15.0002 18.7906 13.8663 18.5636 12.6371L17.3873 6.26672C17.2122 5.31825 16.3851 4.62988 15.4206 4.62988L3.40311 4.62988C2.15308 4.62988 1.20938 5.76379 1.43636 6.99305L2.61266 13.3634C2.78779 14.3119 3.6149 15.0002 4.57941 15.0002Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50005 9.25142C9.46224 9.24512 9.41813 9.24512 9.38032 9.25142C8.51076 9.21991 7.81763 8.50788 7.81763 7.62571C7.81763 6.72464 8.54226 6 9.44333 6C10.3444 6 11.069 6.73094 11.069 7.62571C11.0627 8.50788 10.3696 9.22622 9.50005 9.25142Z",
    fill: "#00A651"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66635 10.5009C6.77788 11.0933 6.77788 12.0636 7.66635 12.656C8.67454 13.3302 10.3255 13.3302 11.3336 12.656C12.2221 12.0636 12.2221 11.0933 11.3336 10.5009C10.3318 9.83302 8.67454 9.83302 7.66635 10.5009Z",
    fill: "#00A651"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderHseWhite);
export default __webpack_public_path__ + "static/media/folder_hse_white.60c61fc355375b2925233af8907b9a52.svg";
export { ForwardRef as ReactComponent };